export const TYPE_MODAL = {
  EVALUATE: "evaluate",
  EDIT: "edit",
  VIEW: "view",
};

export const LEVEL_CIRTERIA = [
  { id: 1, name: "Mức 1" },
  { id: 2, name: "Mức 2" },
  { id: 3, name: "Mức 3" },
  { id: 4, name: "Mức 4" },
  { id: 5, name: "Mức 5" },
];

export const RESULT = [
  { id: "Đạt", name: "Đạt" },
  { id: "Không đạt", name: "Không đạt" },
] as const;

export const RESULT_INDICATOR = [
  { id: 1, name: "Đạt" },
  { id: 0, name: "Không đạt" },
] as const;

export const SURGICAL_SAFETY_RESULT = {
  ACHIEVED: {id: 1, name: "Đạt", multiplier: 1},
  PARTIALLY_ACHIEVED_BELOW: {id: 2, name: "Đạt một phần < 50%", multiplier: 0},
  PARTIALLY_ACHIEVED_ABOVE: {id: 3, name: "Đạt một phần >= 50%", multiplier: 0.5},
  NOT_ACHIEVED: {id: 4, name: "Không đạt", multiplier: 0}
};

export const EVALUATE_STATUS = {
  NOT_RATE_YET: {
    code: 1,
    name: "Chưa đánh giá",
  },
  EVALUETING: {
    code: 2,
    name: "Đang đánh giá",
  },
  EVALUATED: {
    code: 3,
    name: "Đã đánh giá",
  },
};

export const TYPE_CONFIRM_DIALOG = {
  COMPLETE_EVALUATE: "completeEvaluate",
};

export const MESSAGE_CONFIRM_DIALOG = {
  [TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE]:
    "Bạn có chắc chắn muốn hoàn thành đánh giá các tiêu chí đã chọn không?",
};

export const QUALITY_INDICATOR_SEPARATOR = "-";

export const QI_CRITERIA_CODES = {
  CLINICAL_INCIDENT: "3B3",
  NON_CLINICAL_INCIDENT: "3B4",
}

export const CLINICAL_INCIDENT_INDEXES = {
  MEDICAL_USE_OF_CI: 0,
  ADVERSE_DRUG_EFFECTS_OF_CI: 1,
  RELATED_TO_SURGERY_OF_CI: 2,
  MEDICAL_PROCEDURE_OF_CI: 3,
  BLOOD_TRANSFUSION_OF_CI: 4,
  OTHERS_OF_CI: 5,
}

export const CLINICAL_MAPPING = {
  [CLINICAL_INCIDENT_INDEXES.MEDICAL_USE_OF_CI]: "medicalUseOfCI",
  [CLINICAL_INCIDENT_INDEXES.ADVERSE_DRUG_EFFECTS_OF_CI]: "adverseDrugEffectsOfCI",
  [CLINICAL_INCIDENT_INDEXES.RELATED_TO_SURGERY_OF_CI]: "relatedToSurgeryOfCI",
  [CLINICAL_INCIDENT_INDEXES.MEDICAL_PROCEDURE_OF_CI]: "medicalProcedureOfCI",
  [CLINICAL_INCIDENT_INDEXES.BLOOD_TRANSFUSION_OF_CI]: "bloodTransfusionOfCI",
  [CLINICAL_INCIDENT_INDEXES.OTHERS_OF_CI]: "othersOfCI",
};

export const NON_CLINICAL_INCIDENT_INDEXES = {
  SUICIDE_NCI: 0,
  HEIGHT_FALLING_NCI: 1,
  CHILD_ABDUCTION_NCI: 2,
  VIOLENCE_RELATED_NCI: 3,
  EXPLOSION_NCI: 4,
  HAZARDOUS_MATERIAL_LOSS_NCI: 5,
  OTHERS_NCI: 6,
};

export const NON_CLINICAL_MAPPING = {
  [NON_CLINICAL_INCIDENT_INDEXES.SUICIDE_NCI]: "suicideNCI",
  [NON_CLINICAL_INCIDENT_INDEXES.HEIGHT_FALLING_NCI]: "heightFallingNCI",
  [NON_CLINICAL_INCIDENT_INDEXES.CHILD_ABDUCTION_NCI]: "childAbductionNCI",
  [NON_CLINICAL_INCIDENT_INDEXES.VIOLENCE_RELATED_NCI]: "violenceRelatedNCI",
  [NON_CLINICAL_INCIDENT_INDEXES.EXPLOSION_NCI]: "explosionNCI",
  [NON_CLINICAL_INCIDENT_INDEXES.HAZARDOUS_MATERIAL_LOSS_NCI]: "hazardousMaterialLossNCI",
  [NON_CLINICAL_INCIDENT_INDEXES.OTHERS_NCI]: "othersNCI",
};
